module.exports = __webpack_public_path__ + "img/product_02.ff1b83d3.png";